export const inventoryDefault = {
  inventory: [],
}

const setInventory = (state, value) => ({ ...state, inventory: value })

const setClearInventory = () => ({
  ...inventoryDefault,
})

const setProductAvailability = (state, { id, isChecked, isScheduled }) => {
  const inventory = state.inventory.map(item => {
    if (item.product.id === id) {
      const modifiedProduct = { ...item }
      modifiedProduct[
        isScheduled ? 'isScheduledItemAvailable' : 'isAvailable'
      ] = isChecked
      return modifiedProduct
    }
    return item
  })

  return { ...state, inventory }
}

const setProductPromotion = (state, { productVariantId, newOptIn }) => {
  const inventory = state.inventory.map(item => {
    if (item.productPrices?.productVariantId === productVariantId) {
      return {
        ...item,
        productPrices: {
          ...item.productPrices,
          sellerDiscountOpt: {
            ...item.productPrices?.sellerDiscountOpt,
            optIn: newOptIn,
          },
        },
      }
    }
    return item
  })

  return { ...state, inventory }
}

const inventoryActions = {
  INVENTORY: setInventory,
  CLEAR_INVENTORY: setClearInventory,
  CHANGE_PRODUCT_AVAILABILITY: setProductAvailability,
  CHANGE_PRODUCT_PROMOTION: setProductPromotion,
}

const inventoryReducer = (state, action) => {
  return inventoryActions[action.type](state, action.value)
}

export default inventoryReducer
